import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cx-header-tooltip-button',
  templateUrl: './cx-header-tooltip-button.component.html',
  styleUrls: ['./cx-header-tooltip-button.component.scss']
})
export class CxHeaderTooltipButtonComponent implements OnInit {
  @Input() text: string;
  @Input() icon: string;
  @Input() link: string;
  constructor() { }

  ngOnInit(): void {
  }

}
